import { Ledger, Voucher, StockGroup, StockItem, UnitOfMeasurement, AuditEntry } from "./types";

// ========================
// SEED LEDGERS (Chart of Accounts)
// Production-ready: empty — data comes from database
// ========================

export const SEED_LEDGERS: Ledger[] = [];

// ========================
// SEED VOUCHERS
// Production-ready: empty — data comes from database
// ========================

export const SEED_VOUCHERS: Voucher[] = [];

// ========================
// SEED STOCK DATA
// Production-ready: empty — data comes from database
// ========================

export const SEED_STOCK_GROUPS: StockGroup[] = [];

export const SEED_UNITS: UnitOfMeasurement[] = [
  { id: "u-kg", symbol: "KG", formalName: "Kilograms", decimalPlaces: 2 },
  { id: "u-m", symbol: "M", formalName: "Metres", decimalPlaces: 2 },
  { id: "u-pcs", symbol: "PCS", formalName: "Pieces", decimalPlaces: 0 },
  { id: "u-bags", symbol: "Bags", formalName: "Bags", decimalPlaces: 0 },
  { id: "u-l", symbol: "L", formalName: "Litres", decimalPlaces: 2 },
  { id: "u-box", symbol: "Box", formalName: "Boxes", decimalPlaces: 0 },
  { id: "u-ton", symbol: "Ton", formalName: "Metric Tonnes", decimalPlaces: 3 },
];

export const SEED_STOCK_ITEMS: StockItem[] = [];

// ========================
// SEED AUDIT LOG
// Production-ready: empty — data comes from database
// ========================

export const SEED_AUDIT_LOG: AuditEntry[] = [];
